import {
  validationGenerator,
  appearanceGenerator,
  visibilityGenerator,
  permissionGenerator
} from "../validations";
import { constructGridFieldObj, getChildColumns } from "./flow.util";
import { FieldURLMapping } from "./url";
import { PublicFieldURLMapping } from "./public.url";

const shouldValidate = (columnConfig) => {
  return (
    !columnConfig["isReadOnly"] || columnConfig["isExpression"]
    // columnConfig["renderedOnUI"] &&
    // columnConfig["permission"] &&
    // columnConfig["permission"] !== "Hidden"
  );
};

const validateField = (
  columnId,
  formData = {},
  modelConfig = {},
  visibility = {},
  skipDependentFields
) => {
  let error = [];
  let validationList =
    modelConfig[columnId] && modelConfig[columnId].validations;
  let renderedOnUI = visibility["_root"] && visibility["_root"][columnId];
  validationList &&
    renderedOnUI &&
    validationList.forEach((validation) => {
      let result = validation(formData);
      if (result) {
        error = [...error, ...result];
      }
    });
  if (!skipDependentFields) {
    let dependentFields =
      modelConfig[columnId] && modelConfig[columnId].dependentFields;
    dependentFields &&
      dependentFields.forEach((field) => {
        let columnId = field.columnId;
        if (shouldValidate(modelConfig[columnId])) {
          validateField(columnId, formData, modelConfig, visibility, true);
        }
      });
  }
  return { fieldId: modelConfig[columnId]["id"], error: error };
};

const validateForm = (formData, modelConfig, rootId, visibility) => {
  let formError = {};
  for (let modelName in modelConfig) {
    if (modelName === rootId) {
      let model = modelConfig[modelName];
      for (let column in model) {
        let columnConfig = model[column];
        if (shouldValidate(columnConfig)) {
          let errorObj = validateField(
            column,
            formData,
            modelConfig[modelName],
            visibility
          );
          formError = updateFieldError(
            errorObj.fieldId,
            errorObj.error,
            formError
          );
        }
      }
    } else {
      formError = validateGrid(
        formData,
        modelName,
        modelConfig,
        formError,
        visibility
      );
    }
  }
  return formError;
};

const isReadOnly = (field) => {
  return (
    (field && field["Field::Expression"]) || field.Widget === "Aggregation"
  );
};

const getFormColumns = (model, accessChildModels, systemFields) => {
  let fieldList = model.getList("Model", "Field");
  let childModels = model.getList("Model", "Model");
  let modelConfiguration = {};
  modelConfiguration[model.getValue("Id")] = {};
  let parentModelConfiguration = modelConfiguration[model.getValue("Id")];
  if (childModels && childModels.length > 0 && accessChildModels) {
    childModels.forEach((childModel) => {
      let childRow = childModel.getList("Model", "Row");
      let columnList = childRow[0] && childRow[0].getList("Row", "Column");
      let childColumnIdList = columnList.map((column) => {
        let field = column.getList("Column", "Field")[0];
        return field && field["currentJson"];
      });
      let childModelConfig = constructGridFieldObj(model, childColumnIdList);
      modelConfiguration = {
        ...modelConfiguration,
        [childModel.getValue("Id")]: childModelConfig
      };
      if (!modelConfiguration[model.getValue("Id")][model.getValue("Column")]) {
        let modelColumn = model.getObject(model.getValue("Column"));
        modelConfiguration[model.getValue("Id")][model.getValue("Column")] = {
          type: modelColumn.getValue("Type"),
          id: childModel.getValue("Id")
        };
      }
    });
  }
  fieldList.forEach((field) => {
    let column = model.getObject(field.getValue("Column"));
    let columnId = column.getValue("Id");
    parentModelConfiguration[columnId] = {
      ...parentModelConfiguration[columnId],
      name: field.getValue("Name"),
      id: field.getValue("Id"),
      columnId: field.getValue("Column"),
      type: column.getValue("Type")
    };
    let parentRow = model.getObject(column.getValue("Row"));
    let parentColumn = model.getObject(parentRow.getValue("Column"));
    let [validationGeneratorResult, validationDependentFields] =
      validationGenerator(field, [], systemFields);
    // eslint-disable-next-line no-unused-vars
    let [appearanceResult, appearanceDependentFields] = appearanceGenerator(
      column,
      [],
      "",
      systemFields
    );
    let visibilityGeneratorResult = visibilityGenerator(column, systemFields);
    let visibilitySectionGeneratorResult = visibilityGenerator(
      parentColumn,
      systemFields
    );
    if (
      visibilitySectionGeneratorResult &&
      !visibilitySectionGeneratorResult.isEmpty()
    ) {
      if (!parentModelConfiguration[parentColumn.getValue("Id")]) {
        parentModelConfiguration[parentColumn.getValue("Id")] = {
          name: parentColumn.getValue("Name"),
          id: parentColumn.getValue("Id"),
          type: parentColumn.getValue("Type")
        };
      }
      parentModelConfiguration[parentColumn.getValue("Id")]["visibility"] =
        visibilitySectionGeneratorResult;
    }
    if (validationGeneratorResult && validationGeneratorResult.length > 0) {
      parentModelConfiguration[columnId]["validations"] =
        validationGeneratorResult;
      if (
        parentModelConfiguration[columnId]["dependentFields"] &&
        parentModelConfiguration[columnId]["dependentFields"].length > 0
      ) {
        parentModelConfiguration[columnId]["dependentFields"] = [
          ...parentModelConfiguration[columnId]["dependentFields"],
          ...validationDependentFields
        ];
      } else {
        parentModelConfiguration[columnId]["dependentFields"] =
          validationDependentFields;
      }
    }
    if (visibilityGeneratorResult && visibilityGeneratorResult.length > 0) {
      parentModelConfiguration[columnId]["visibility"] =
        visibilityGeneratorResult;
    }
    // parentModelConfiguration[columnId]["parentVisibility"] = visibilitySectionGeneratorResult;
    parentModelConfiguration[columnId]["appearance"] = appearanceResult;
    parentModelConfiguration[columnId]["isReadOnly"] = isReadOnly(
      field.currentJson
    );
    parentModelConfiguration[columnId]["isExpression"] =
      parentModelConfiguration[columnId]["isReadOnly"];
    if (validationDependentFields.length > 0) {
      validationDependentFields.forEach((dependentField) => {
        let dependentFieldObject = model.getObject(dependentField.fieldId);
        let dependentFieldColumn = model.getObject(dependentField.columnId);
        if (!parentModelConfiguration[dependentFieldColumn.getValue("Id")]) {
          parentModelConfiguration[dependentFieldColumn.getValue("Id")] = {
            name: dependentFieldObject.getValue("Name"),
            id: dependentFieldObject.getValue("Id"),
            columnId: dependentFieldObject.getValue("Column"),
            dependentFields: []
          };
        }
        if (
          !parentModelConfiguration[dependentFieldColumn.getValue("Id")][
            "dependentFields"
          ]
        ) {
          parentModelConfiguration[dependentFieldColumn.getValue("Id")][
            "dependentFields"
          ] = [];
        }
        parentModelConfiguration[dependentFieldColumn.getValue("Id")][
          "dependentFields"
        ] = [
          ...parentModelConfiguration[dependentFieldColumn.getValue("Id")][
            "dependentFields"
          ],
          {
            fieldId: field.getValue("Id"),
            columnId
          }
        ];
      });
    }
  });
  return modelConfiguration;
};

const getPermissionGeneratorList = (
  model,
  column,
  config,
  modelConfiguration,
  modelId,
  columnObject
) => {
  let parentRow = model.getObject(columnObject.getValue("Row"));
  let parentColumn = parentRow && model.getObject(parentRow.getValue("Column"));
  let parentPermission;
  if (!modelConfiguration[modelId]) {
    modelConfiguration[modelId] = {};
  }
  if (!modelConfiguration[modelId][column]) {
    modelConfiguration[modelId][column] = {};
  }
  if (parentColumn) {
    parentPermission = permissionGenerator(
      parentColumn,
      null,
      config.isStartStep,
      config.currentStep,
      config.status,
      config.isSendBackToInitiator
    );
    parentPermission = parentPermission["ColumnPermission"];
    let parentColumnId = parentColumn.getValue("Id");
    if (!modelConfiguration[modelId][parentColumnId]) {
      modelConfiguration[modelId][parentColumnId] = {
        type: parentColumn.getValue("Type")
      };
    }
    modelConfiguration[modelId][parentColumnId]["permission"] =
      parentPermission;
  }
  let permissionGeneratorResult = permissionGenerator(
    columnObject,
    parentPermission,
    config.isStartStep,
    config.currentStep,
    config.status,
    config.isSendBackToInitiator
  );
  permissionGeneratorResult =
    permissionGeneratorResult && permissionGeneratorResult["ColumnPermission"];
  modelConfiguration[modelId][column]["permission"] = permissionGeneratorResult;
  return permissionGeneratorResult;
};

const getFormConfiguration = (model, flowConfig, systemFields) => {
  let modelConfiguration = getFormColumns(model, false, systemFields); //pass as argument
  let childModels = model.getList("Model", "Model");
  childModels.forEach((childModel) => {
    let parentModelId = childModel.getModel().getValue("Id");
    let column = model.getObject(childModel.getValue("Column"));
    let columnId = column.getValue("Id");
    // let parentPermission = permissionGenerator(
    //   column,
    //   null,
    //   flowConfig.isStartStep,
    //   flowConfig.currentStep,
    //   flowConfig.status,
    //   flowConfig.isSendBackToInitiator
    // );
    // let permissionObject = {
    //   [columnId]: parentPermission
    // };
    let childColumnList = getChildColumns(
      column,
      undefined,
      flowConfig,
      systemFields
    );
    modelConfiguration[childModel.getValue("Id")] = childColumnList;
    if (!modelConfiguration[parentModelId][columnId]) {
      modelConfiguration[parentModelId][columnId] = {
        type: column.getValue("Type"),
        id: childModel.getValue("Id")
      };
    }
    let visibilitySectionGeneratorResult = visibilityGenerator(
      column,
      systemFields
    );
    if (
      visibilitySectionGeneratorResult &&
      !visibilitySectionGeneratorResult.isEmpty()
    ) {
      modelConfiguration[parentModelId][columnId]["visibility"] =
        visibilitySectionGeneratorResult;
    }
    // modelConfiguration[parentModelId][columnId]["permission"] =
    //   parentPermission["ColumnPermission"];
    // modelConfiguration[parentModelId][columnId]["isReadOnly"] =
    //   (parentPermission["ColumnPermission"] === "ReadOnly" &&
    //     !flowConfig.isAdmin) ||
    //   modelConfiguration[parentModelId][columnId]["isReadOnly"];
  });
  for (let modelId in modelConfiguration) {
    for (let column in modelConfiguration[modelId]) {
      let columnObject = model.getObject(column);
      // let permissionGeneratorResult = getPermissionGeneratorList(
      //   model,
      //   column,
      //   flowConfig,
      //   modelConfiguration,
      //   modelId,
      //   columnObject
      // );
      // modelConfiguration[modelId][column]["isReadOnly"] =
      //   (permissionGeneratorResult === "ReadOnly" && !flowConfig.isAdmin) ||
      //   modelConfiguration[modelId][column]["isReadOnly"];
      let [appearanceResult] = appearanceGenerator(
        columnObject,
        [],
        flowConfig.currentStep,
        systemFields
      );
      modelConfiguration[modelId][column]["appearance"] = appearanceResult;
      modelConfiguration[modelId][column]["sourceUrl"] = getSourceUrl(
        model,
        columnObject,
        flowConfig.isPublicForm
      );
    }
    return modelConfiguration;
  }
};

const validateGrid = (
  formData,
  modelId,
  modelConfig,
  formError,
  visibility,
  changeSummary
) => {
  let rows = formData.getList(modelId);
  // filter only updated rows on bulk operations like cell paste/ delete
  let updatedColumnsList = [];
  rows = changeSummary
    ? changeSummary.map((changedrow) => {
        updatedColumnsList = new Set([
          ...updatedColumnsList,
          ...Object.keys(changedrow)
        ]);
        return rows.find((row) => row.getValue("_id") === changedrow._id);
      })
    : rows;
  rows.forEach((row) => {
    if (changeSummary) {
      formError = validateUpdatedCells(
        formData,
        modelId,
        modelConfig,
        row,
        formError,
        visibility,
        updatedColumnsList
      );
    } else {
      formError = validateRow(
        formData,
        modelId,
        modelConfig,
        row,
        formError,
        visibility
      );
    }
  });
  return formError;
};

const validateUpdatedCells = (...props) => {
  let [
    formData,
    modelId,
    modelConfig,
    row,
    formError,
    visibility,
    updatedColumnsList
  ] = props;
  let model = modelConfig[modelId];
  for (let column in model) {
    let columnConfig = model[column];
    if (updatedColumnsList && updatedColumnsList.has(columnConfig.Id)) {
      let errorObj = validateGridCell(
        columnConfig,
        row,
        modelId,
        visibility,
        formData
      );
      if (errorObj) {
        formError = updateGridFieldError(
          errorObj.modelId,
          errorObj.rowId,
          errorObj.fieldId,
          errorObj.error,
          formError
        );
      }
    }
  }
  return formError;
};

const validateRow = (
  formData,
  modelId,
  modelConfig,
  row,
  formError,
  visibility
) => {
  let model = modelConfig[modelId];
  for (let column in model) {
    let columnConfig = model[column];
    // if (shouldValidate(columnConfig)) {
    let errorObj = validateGridCell(
      columnConfig,
      row,
      modelId,
      visibility,
      formData
    );
    if (errorObj) {
      formError = updateGridFieldError(
        errorObj.modelId,
        errorObj.rowId,
        errorObj.fieldId,
        errorObj.error,
        formError
      );
    }
    // }
  }
  return formError;
};

const validateGridCell = (column, row, modelId, visibility, formData) => {
  let error = [];
  if (checkFieldValidation(column)) {
    let validationList = column.Validationfun || [];
    let columnId = column.Column;
    let renderedOnUI =
      visibility[modelId] &&
      visibility[modelId][row.id || row._id] &&
      visibility[modelId][row.id || row._id][columnId];
    renderedOnUI &&
      validationList.forEach((validation) => {
        let result = validation(row, formData);
        if (result) {
          error = [...error, ...result];
        }
      });
    return {
      modelId: modelId,
      rowId: row.id,
      fieldId: column.Id,
      error: error
    };
  }
};

export {
  getFormColumns,
  validateField,
  getFormConfiguration,
  validateForm,
  validateGrid,
  validateGridCell,
  getPermissionGeneratorList
};

const getSourceUrl = (model, columnObject, isPublicForm) => {
  let mapping = FieldURLMapping;
  if (isPublicForm) {
    mapping = PublicFieldURLMapping;
  }
  let fields = columnObject.getList("Column", "Field");
  if (!fields.isEmpty()) {
    let fieldType = fields[0].getValue("Type");
    return mapping[fieldType];
  }
};

export function shouldAutoSave(field, saveChanges) {
  return (
    saveChanges ||
    field["Field::Node"] ||
    field["Field::RemoteLookup"] ||
    field["Autofill::QueryDefinition"] ||
    field["RemoteLookup::QueryDefinition"] ||
    field["Aggregate::QueryDefinition"] ||
    field["RHSField::Condition"] ||
    field["LHSOwnField::Condition"] ||
    field["ValueField::Property"]
  );
}

const EXPRESSION = "Field::Expression";
const CRITERIA = "FieldValidation::Criteria";
const REQUIRED = "Required";
const QUERY_DEFINITION = "QueryDefinition";
const AUTO_FILL = "AutoFill";

export function checkFieldValidation(field) {
  let validate = false;
  if (field[EXPRESSION]) {
    //validate for expression fields
    validate = true;
  } else if (!field.ReadOnly && (field[REQUIRED] || field[CRITERIA])) {
    //validate for editable fields with validation
    validate = true;
  } else if (
    field[QUERY_DEFINITION] &&
    field[QUERY_DEFINITION].getValue(AUTO_FILL)
  ) {
    //validate for auto select user
    validate = true;
  }
  return validate;
}

export function updateGridFieldError(
  tableId,
  rowId,
  fieldId,
  error,
  formError
) {
  let errorObj = { ...formError };
  if (errorObj[tableId] === undefined) {
    errorObj[tableId] = {};
  } else {
    errorObj[tableId] = { ...errorObj[tableId] };
  }
  if (errorObj[tableId][rowId] === undefined) {
    errorObj[tableId][rowId] = {};
  } else {
    errorObj[tableId][rowId] = { ...errorObj[tableId][rowId] };
  }
  if (error && !error.isEmpty()) {
    errorObj[tableId][rowId][fieldId] = error;
  } else {
    Reflect.deleteProperty(errorObj[tableId][rowId], fieldId);
  }
  return errorObj;
}

export function clearTableRowError(tableId, rowIds, formError) {
  let errorObj = { ...formError };
  if (errorObj[tableId] === undefined) {
    errorObj[tableId] = {};
  } else {
    errorObj[tableId] = { ...errorObj[tableId] };
  }
  rowIds.forEach((rowId) => Reflect.deleteProperty(errorObj[tableId], rowId));
  return errorObj;
}

export function updateFieldError(fieldId, error, formError) {
  let errorObj = { ...formError };
  if (errorObj["_root"] === undefined) {
    errorObj["_root"] = {};
  } else {
    errorObj["_root"] = { ...errorObj["_root"] };
  }
  if (error && !error.isEmpty()) {
    errorObj["_root"][fieldId] = error;
  } else {
    Reflect.deleteProperty(errorObj["_root"], fieldId);
  }
  return errorObj;
}

export function updateGridFieldVis(
  tableId,
  rowId,
  fieldId,
  vis,
  formVisibility
) {
  let visObj = { ...formVisibility };
  if (visObj[tableId] === undefined) {
    visObj[tableId] = {};
  } else {
    visObj[tableId] = { ...visObj[tableId] };
  }
  if (visObj[tableId][rowId] === undefined) {
    visObj[tableId][rowId] = {};
  } else {
    visObj[tableId][rowId] = { ...visObj[tableId][rowId] };
  }
  visObj[tableId][rowId][fieldId] = vis;
  return visObj;
}
export function updateFieldVis(fieldId, vis, formVisibility) {
  let visObj = { ...formVisibility };
  if (visObj["_root"] === undefined) {
    visObj["_root"] = {};
  } else {
    visObj["_root"] = { ...visObj["_root"] };
  }
  visObj["_root"][fieldId] = vis;
  return visObj;
}

export function shouldTriggerSave(changeSet) {
  let shouldTrigger = false;
  if (changeSet) {
    let keys = Object.keys(changeSet);
    keys.forEach((key) => {
      if (key.indexOf("Table::") === 0) {
        if (changeSet[key].length > 0) {
          shouldTrigger = true;
        }
      } else if (key !== "_id") {
        shouldTrigger = true;
      }
    });
  }
  return shouldTrigger;
}
